"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../data/interfaces");
var moment_1 = __importDefault(require("moment"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var getRulesByUserProfileType = function (rules, userProfileType) {
    var newRules;
    switch (userProfileType) {
        case interfaces_1.UserProfileType.Student:
            newRules = rules.student;
            break;
        case interfaces_1.UserProfileType.Staff:
            newRules = rules.staff;
            break;
        default:
            newRules = {};
            console.log("No rules were found for userProfileType: " + userProfileType);
            break;
    }
    return newRules;
};
exports.getRulesByUserProfileType = getRulesByUserProfileType;
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
var getPartsByDelimiter = function (value) {
    return value.split(DELIMITER);
};
exports.getPartsByDelimiter = getPartsByDelimiter;
var EASTERN_TIME_ZONE = "America/New_York";
var convertToLocalDate = function (date) {
    return moment_timezone_1.default(date).tz(EASTERN_TIME_ZONE).format("MMM D, YYYY h:mm A zz");
};
exports.convertToLocalDate = convertToLocalDate;
var convertToLocalDateFormat = function (date) { return moment_1.default(date).format("MM/DD/YYYY"); };
exports.convertToLocalDateFormat = convertToLocalDateFormat;
var formatToStringDate = function (date) { return moment_1.default(new Date(date)).format("MM/DD/YYYY HH:mm:ss"); };
exports.formatToStringDate = formatToStringDate;
var getFullName = function (json_data) {
    var _a, _b, _c;
    if (!json_data) {
        return "";
    }
    var firstName = (_a = json_data["first_name"]) !== null && _a !== void 0 ? _a : "";
    var middleName = (_b = json_data["middle_name"]) !== null && _b !== void 0 ? _b : "";
    var lastName = (_c = json_data["last_name"]) !== null && _c !== void 0 ? _c : "";
    return firstName + " " + middleName + " " + lastName;
};
exports.getFullName = getFullName;
var isCountryUS = function (country) {
    if (!country) {
        return false;
    }
    var _a = getPartsByDelimiter(country), countryValue = _a[2];
    return countryValue === "United States";
};
exports.isCountryUS = isCountryUS;
//# sourceMappingURL=data:application/json;base64,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